import { IControl } from "../icontrol";
import { ControlType } from "../../controltype";
import { EnumType } from "./enumtype";
import { IEnumValue, EnumValueConvert } from "./ienumvalue";
import { EnumStringValue } from "./stringenumvalue";
import { EnumBoolValue } from "./boolenumvalue";
import { EnumIntegerValue } from "./integerenumvalue";

/**
 * 下拉列表控件
 */
export class DropDownControl implements IControl{

    /**
     * 获取控件类型
     */
    getControlType(): ControlType {
        return ControlType.DropDown;
    }

    /**
     * 下拉值类型
     */
    valueType:EnumType;
    /**
     * 默认显示
     */
    placeholder:string;
    /**
     * 下拉数据源列表
     * 该属性为IEnumValue接口类型，具体实现类如下：
     * 1.布尔类型：EnumBoolValue,布尔类型的控件会转成下拉列表，实现类使用EnumBoolValue
     * 2.字符串类型：EnumStringValue
     * 3.整型类型：EnumIntegerValue 例如Radio Button类型需要使用EnumIntegerValue实现类
     */
    enumValues:Array<IEnumValue>;

    /**
     * 是否是展示在扩展区域内的
     */
    isExtend:boolean;

    /**是否显示label */
    showLabel:boolean;
    /**是否必填 */
    required:boolean;

    editable: boolean;
}

/**
 * 下拉列表控件序列化与反序列化器
 */
export class DropDownListControlConvert{

    /**
     * 序列化
     * @param obj 下拉列表控件实体
     */
    convertToObject(obj:DropDownControl){
        let dropDownListControl= obj as DropDownControl;
        let jobj=new Object();
        jobj["valueType"]=dropDownListControl.valueType;
        if(dropDownListControl.enumValues!=null){
            let jarray=jobj["enumValues"]=[];
            let convertor=new EnumValueConvert();
            dropDownListControl.enumValues.forEach(element => {
                if(dropDownListControl.valueType==EnumType.BoolType){
                    jarray.push(convertor.convertJObject(Object.assign(new EnumBoolValue(),element)));
                }
                else if(dropDownListControl.valueType==EnumType.IntType){
                    jarray.push(convertor.convertJObject(Object.assign(new EnumIntegerValue(),element)));
                }
                else{
                    jarray.push(convertor.convertJObject(Object.assign(new EnumStringValue(),element)));
                }
            });
        }
        return jobj;
    }

    /**
     * 反序列化
     * @param jobj 下拉列表控件实体序列化后的JSON对象
     */
    initFromObject(jobj:Object):DropDownControl{
        let control=new DropDownControl();
        if(jobj["valueType"]!=null){
            control.valueType=jobj["valueType"] as number;
        }
        if(jobj["enumValues"]!=null){
            control.enumValues=new Array<IEnumValue>();
            jobj["enumValues"].forEach(element => {
                let convertor=new EnumValueConvert();
                control.enumValues.push(convertor.initFromJobject(element));
            });
        }
        return control;
    }
}